// LAYOUT
// ----------------------------------------------------------------------
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 72,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'rtl',
  themeColorPresets: 'purple',
  themeLayout: 'horizontal',
  themeStretch: true,
};

export const Paths = {
  participants: {
    list: {
      title: 'لیست مشارکت کننده ها',
      path: '/course/participant',
    },
  },
  courses: {
    list: {
      title: 'لیست دوره ها',
      path: '/course/list',
    },
    create: {
      title: 'ایجاد دوره',
      path: '/course/create',
    },
    edit: {
      title: 'ویرایش دوره',
      path: '/course/edit',
    },
    delete: {
      title: 'حذف دوره',
      path: '/course/delete',
    },
  },
  faq: {
    list: {
      title: 'لیست سوالات متداول',
      path: '/faq/list',
    },
    create: {
      title: 'ایجاد سوالات متداول',
      path: '/faq/create',
    },
    edit: {
      title: 'ویرایش سوالات متداول',
      path: '/faq/edit',
    },
    delete: {
      title: 'حذف سوالات متداول',
      path: '/faq/delete',
    },
  },
  story: {
    list: {
      title: 'لیست استوری ها',
      path: '/story/list',
    },
    create: {
      title: 'ایجاد استوری',
      path: '/story/create',
    },
    edit: {
      title: 'ویرایش استوری',
      path: '/story/edit',
    },
    delete: {
      title: 'حذف استوری',
      path: '/story/delete',
    },
  },
  slider: {
    list: {
      title: 'لیست اسلایدر ها',
      path: '/slider/list',
    },
    create: {
      title: 'ایجاد اسلایدر',
      path: '/slider/create',
    },
    edit: {
      title: 'ویرایش اسلایدر',
      path: '/slider/edit',
    },
    delete: {
      title: 'حذف اسلایدر',
      path: '/slider/delete',
    },
  },
  courseLevels: {
    list: {
      title: 'لیست سطوح دوره ها',
      path: '/course-level/list',
    },
    create: {
      title: 'ایجاد سطح دوره',
      path: '/course-level/create',
    },
    edit: {
      title: 'ویرایش سطح دوره',
      path: '/course-level/edit',
    },
    delete: {
      title: 'حذف سطح دوره',
      path: '/course-level/delete',
    },
  },
  trainer: {
    list: {
      title: 'لیست مدرسین',
      path: '/trainer/list',
    },
    create: {
      title: 'ایجاد مدرس',
      path: '/trainer/create',
    },
    edit: {
      title: 'ویرایش مدرس',
      path: '/trainer/edit',
    },
    delete: {
      title: 'حذف مدرس',
      path: '/trainer/delete',
    },
  },
  contentType: {
    list: {
      title: 'لیست نوع محتوا ها',
      path: '/content-type/list',
    },
    create: {
      title: 'ایجاد نوع محتوا',
      path: '/content-type/create',
    },
    edit: {
      title: 'ویرایش نوع محتوا',
      path: '/content-type/edit',
    },
    delete: {
      title: 'حذف نوع محتوا',
      path: '/content-type/delete',
    },
  },
  category: {
    list: {
      title: 'لیست دسته بندی',
      path: '/category/list',
    },
    create: {
      title: 'ایجاد دسته بندی',
      path: '/category/create',
    },
    edit: {
      title: 'ویرایش دسته بندی',
      path: '/category/edit',
    },
    delete: {
      title: 'حذف دسته بندی',
      path: '/category/delete',
    },
  },
  tag: {
    list: {
      title: 'لیست برچسب ها',
      path: '/tag/list',
    },
    create: {
      title: 'ایجاد برچسب',
      path: '/tag/create',
    },
    edit: {
      title: 'ویرایش برچسب',
      path: '/tag/edit',
    },
    delete: {
      title: 'حذف برچسب',
      path: '/tag/delete',
    },
  },
  package: {
    list: {
      title: 'لیست پکیج ها',
      path: '/package/list',
    },
    create: {
      title: 'ایجاد پکیج',
      path: '/package/create',
    },
    edit: {
      title: 'ویرایش پکیج',
      path: '/package/edit',
    },
    delete: {
      title: 'حذف پکیج',
      path: '/package/delete',
    },
  },
};

export const TableConfig = {
  size: 'medium',
};

export const TablePaginationDefaults = {
  page: 1,
  rowsPerPage: 15,
};

export const BASE_URL =
  process.env.REACT_APP_DEBUG === 'true' ? process.env.REACT_APP_URL_DEBUG : process.env.REACT_APP_URL_PRODUCT;

export const Endpoints = {
  course: {
    list: '/course/list',
    handleAbsorptionPeriod: '/course/featured',
    knowledge: '/course/knowledge',
    activate: '/course/active',
    deactivate: '/course/deactive',
    archive: '/course/archive',
  },
  participants: {
    list: '/course/participants/',
  },
  faq: {
    list: '/faq/list',
    create: '/faq/create',
    update: '/faq/update',
  },
  slider: {
    list: '/slider/list',
    create: '/admin/slider/create',
    update: '/admin/slider/update',
  },
  story: {
    list: '/story',
    create: '/admin/story/create',
    update: '/admin/story/update',
  },
  courseLevels: {
    list: '/course-level/all',
    create: '/course-level/create',
    edit: '/course-level/update',
    delete: '/course-level/remove',
  },
  trainer: {
    list: '/teacher/all',
    create: '/teacher/create',
    edit: '/teacher/update',
    delete: '/teacher/remove',
  },
  contentType: {
    list: '/content-type/all',
    create: '/content-type/create',
    edit: '/content-type/update',
    delete: '/content-type/remove',
  },
  category: {
    list: '/admin/category/all',
    create: '/category/create-one',
    edit: '/category/update',
    delete: '/category/remove',
  },
  tag: {
    list: '/tag/all',
    create: '/tag/create',
    edit: '/tag/update',
    delete: '/tag/remove',
  },
  package: {
    list: '/package/all',
    create: '/package/create',
    edit: '/package/update',
    delete: '/package/remove',
  },
};
